<p-table
  [value]="value()"
  [lazy]="true"
  [paginator]="totalRecords() > 0"
  [first]="first()"
  [rows]="rows()"
  [totalRecords]="totalRecords()"
  [loading]="isLoading()"
  [tableStyleClass]="tableStyleClass()"
  (onLazyLoad)="lazyLoad.emit($event)"
  [showFirstLastIcon]="false"
>
  <ng-template #header>
    <ng-container [ngTemplateOutlet]="headerTpl ?? null"></ng-container>
  </ng-template>

  <ng-template #body let-item>
    <ng-container [ngTemplateOutlet]="bodyTpl ?? null" [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
  </ng-template>

  <ng-template #emptymessage>
    <ng-container [ngTemplateOutlet]="emptyTpl ?? null"></ng-container>
  </ng-template>

  <ng-template #loadingbody>
    <ng-container [ngTemplateOutlet]="loadingTpl ?? null"></ng-container>
  </ng-template>

  <ng-template #paginatorleft>
    <app-button
      [btnSize]="ButtonSize.SM"
      [btnSeverity]="ButtonSeverity.SECONDARY"
      (btnClicked)="prevPage.emit()"
      [isBtnDisabled]="!hasPreviousPage()"
    >
      <app-arrow direction="left" stroke="#3D3B3A"></app-arrow>
      <div class="paginator-btn-label text-sm-semibold text-gray-700">Nazad</div>
    </app-button>
  </ng-template>

  <ng-template #paginatorright>
    <app-button
      [btnSize]="ButtonSize.SM"
      [btnSeverity]="ButtonSeverity.SECONDARY"
      (btnClicked)="nextPage.emit()"
      [isBtnDisabled]="!hasNextPage()"
    >
      <div class="paginator-btn-label text-sm-semibold text-gray-700">Dalje</div>
      <app-arrow direction="right" stroke="#3D3B3A"></app-arrow>
    </app-button>
  </ng-template>
</p-table>
